// src/components/billing/AccountingPlanGate.tsx
import type { ReactNode } from 'react';
import { PlanGate } from '@/components/billing/PlanGate';

export const AccountingPlanGate = ({ children }: { children: ReactNode }) => (
  <PlanGate
    required="ADVANCED_ACCOUNTING"
    title="Contabilidad Avanzada"
    description="Auxiliar contable, nómina, centros de costo, comprobantes y producción requieren el plan Contabilidad Avanzada."
  >
    {children}
  </PlanGate>
);

export default AccountingPlanGate;
